<template>
  <span v-clipboard:copy="val" v-clipboard:success="copySuccess" v-clipboard:error="copyError">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'copyValue',
  props: {
    val: {
      default: '',
    },
  },
  methods: {
    copySuccess() {
      this.$f.errTip('common.copySuccess', 'success');
    },
    copyError() {
      this.$f.errTip('common.copyFail');
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/copyValue.vue